
    import { defineComponent, PropType } from "vue";
    import { ApolloClient, DocumentNode, gql, NormalizedCacheObject } from "@apollo/client/core";

    export default defineComponent({
        props: {
            apolloClient: {
                type: Object as PropType<ApolloClient<NormalizedCacheObject>>,
            },

        },
        components: {

        },
        data() {
            return {
                isOpen: false,
                variables: "",
                query: "",

            };
        },
        computed: {

        },
        methods: {
            async sendMutation() {
                const mutation = gql`${this.query}`;
                const res = await this.apolloClient?.mutate({
                    mutation,
                    variables: this.variables ? JSON.parse(this.variables) : {}
                });
                console.log("sendMutation", { res, mutation });
            },

            async sendQuery() {
                const query = gql`${this.query}`;
                const res = await this.apolloClient?.query({
                    query
                });
                console.log("sendQuery", { res, query });
            },

        },
    });

    